import {
  Avatar,
  Breadcrumb,
  Button,
  Divider,
  Form,
  Input,
  Modal,
  message,
} from "antd";
import { SettingFilled } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { UserContext } from "../../../context/User.context";
import { useHttp } from "../../../utils/DataHendler";
import { useMediaQuery } from "react-responsive";

export const ChangePassword = () => {
  const { user, setUser } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const { postData } = useHttp();

  // Deteksi perangkat mobile
  const isMobile = useMediaQuery({ maxWidth: 768 });

  // Handle form submission failure
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  // Handle form submission success
  const onFinish = async (values) => {
    const { oldpassword, newpassword, confirmpassword } = values;
    setLoading(true);
    try {
      await postData(
        "/auth/change-password",
        {
          oldpassword,
          newpassword,
          confirmpassword,
        },
        {},
        true
      );

      setLoading(false);
      setUser(null);
      localStorage.clear();
      navigate("/login");
      message.success(
        location.pathname === "/user/profile/change-pwd"
          ? "Password berhasil dibuat"
          : "Password berhasil diubah. Silakan login kembali."
      );
    } catch (error) {
      setLoading(false);
    }
  };

  // Component for the change password form
  function ChangePasswordForm() {
    return (
      <div
        style={{
          margin: isMobile ? "20px auto" : "50px auto",
          maxWidth: isMobile ? "100%" : "600px",
          padding: isMobile ? "10px" : "0",
        }}
      >
        <h1
          style={{
            textAlign: "center",
            marginBottom: "30px",
            fontSize: isMobile ? "20px" : "24px",
          }}
        >
          Change Password
        </h1>

        <Form
          name="changePasswordForm"
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          {/* Old Password Field */}
          <Form.Item
            label={<span>Old Password</span>}
            name="oldpassword"
            rules={[
              {
                required: true,
                message: "Masukkan kata sandi lama Anda (minimal 6 karakter).",
              },
            ]}
          >
            <Input.Password
              placeholder="Old password"
              style={{
                height: isMobile ? "40px" : "48px",
                fontSize: isMobile ? "14px" : "16px",
              }}
            />
          </Form.Item>

          {/* New Password Field */}
          <Form.Item
            label={<span>New Password</span>}
            name="newpassword"
            rules={[
              {
                required: true,
                min: 6,
                message: "Masukkan kata sandi baru Anda (minimal 6 karakter).",
              },
            ]}
          >
            <Input.Password
              placeholder="New Password"
              style={{
                height: isMobile ? "40px" : "48px",
                fontSize: isMobile ? "14px" : "16px",
              }}
            />
          </Form.Item>

          {/* Confirm Password Field */}
          <Form.Item
            label={<span>Confirm Password</span>}
            name="confirmpassword"
            dependencies={["newpassword"]}
            rules={[
              {
                required: true,
                message: "Konfirmasi kata sandi Anda.",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newpassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Kata sandi tidak cocok."));
                },
              }),
            ]}
          >
            <Input.Password
              placeholder="Confirm Password"
              style={{
                height: isMobile ? "40px" : "48px",
                fontSize: isMobile ? "14px" : "16px",
              }}
            />
          </Form.Item>

          {/* Divider */}
          <Divider style={{ margin: "20px 0" }} />

          {/* Submit Button */}
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={loading}
              style={{
                height: isMobile ? "40px" : "48px",
                borderRadius: 5,
                fontSize: isMobile ? "14px" : "16px",
              }}
            >
              Change Password
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }

  return (
    <div>
      {/* Breadcrumb Navigation */}
      <Breadcrumb
        style={{
          margin: isMobile ? "20px 0 0 20px" : "30px 0 0 100px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        <Breadcrumb.Item>
          <a onClick={() => navigate("/user/profile")}>Profil</a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Change Password</Breadcrumb.Item>
      </Breadcrumb>

      {/* Main Content Container */}
      <div
        style={{
          background: "#fff",
          margin: isMobile ? "20px" : "30px 75px",
          padding: isMobile ? "20px" : "40px",
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px",
          borderRadius: 7,
        }}
      >
        <ChangePasswordForm />
      </div>
    </div>
  );
};
